
export const getAssignments = state => state.entitiesReducer.assignments;

export const getStudents = state => state.entitiesReducer.students;

export const getSortedStudentIds = state => state.UPFAssignReducer.sortedStudentIds;


// WEBPACK FOOTER //
// ./helpers/selectors/common.js